// extracted by mini-css-extract-plugin
export default {"NavigationItems":"NavigationItems_NavigationItems__xOg1n","NavigationItemIcon":"NavigationItems_NavigationItemIcon__ELkLE"};